var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { NoEntityError } from "../validation/validatableentity";
import { StatusCode } from "../http/ajax/statusCode";
var EntityErrorField = "";
function updateByCollectionResponse(draft, response) {
    var collectionResponse = response.data;
    if (response.succeeded) {
        draft.collection = collectionResponse.collection;
        clearErrors(draft);
    }
    if (collectionResponse != null && collectionResponse.errors != null) {
        validationErrorsToEntityErrors(draft, collectionResponse.errors, true);
    }
    else if (!response.succeeded) {
        responseErrorToEntityError(draft, response.status, true);
    }
}
function clearErrors(draft) {
    draft.errors = __assign({}, NoEntityError);
}
function responseErrorToEntityError(draft, status, clearExisting) {
    var message;
    switch (status) {
        case StatusCode.Unauthorized:
            message = "Nemáte oprávnění k provedení akce.";
            break;
        case StatusCode.NotFound:
            message = "Zdroj nenalezen.";
            break;
        case StatusCode.BadRequest:
            message = "Chybný požadavek.";
            break;
        case StatusCode.InternalServerError:
            message = "Interní chyba serveru.";
            break;
        default:
            message = status === undefined ? "Server vrátil neznámý status." : status.toString(); // TODO something user friendly
            break;
    }
    errorToEntityError(draft, message, clearExisting);
}
function errorToEntityError(draft, message, clearExisting, entityField) {
    if (entityField === void 0) { entityField = EntityErrorField; }
    var errors = clearExisting ? __assign({}, NoEntityError) :
        draft.errors;
    errors[entityField] = {
        errors: message,
        evaluate: null
    };
    draft.errors = errors;
}
function validationErrorsToEntityErrors(draft, validationErrors, clearExisting) {
    var errors = clearExisting ? __assign({}, NoEntityError) : draft.errors;
    for (var _i = 0, _a = Object.entries(validationErrors); _i < _a.length; _i++) {
        var validationError = _a[_i];
        errors[validationError[0]] = {
            errors: validationError[1].errors,
            evaluate: null
        };
    }
    draft.errors = errors;
}
export { updateByCollectionResponse, };
